import React from "react";
import { intervalToDuration, format, addDays } from "date-fns";
import {
  format12h,
  format24h,
} from "../../schedule/timeIndicator/TimeIndicator";

const FIXED_DATE = "01/01/2021";
const extractTime = (hour, timeFormat24h) => {
  const timeFormat = timeFormat24h ? format24h : format12h;

  return format(new Date(`${FIXED_DATE} ${hour}`), timeFormat);
};

const getDuration = (timeStart, timeEnd) => {
  const start = new Date(`${FIXED_DATE} ${timeStart}`);
  const end = new Date(`${FIXED_DATE} ${timeEnd}`);

  if (end <= start) {
    // If end time is less than or equal to start time, it means the schedule goes past midnight
    const adjustedEnd = addDays(end, 1);
    return intervalToDuration({ start, end: adjustedEnd });
  }

  return intervalToDuration({ start, end });
};

export const ScheduleDuration = ({ timeStart, timeEnd, timeFormat }) => {
  const startTime = extractTime(timeStart, timeFormat);
  const endTime = extractTime(timeEnd, timeFormat);
  const duration = getDuration(timeStart, timeEnd);

  const a11yStartTime = extractTime(timeStart, format24h);
  const a11yEndTime = extractTime(timeEnd, format24h);

  if (duration?.days) {
    duration.hours += 24; // We do not expect days to be more than 1
  }

  let durationMessage =
      duration.hours === 0
      ? `${duration.minutes}m`
      : duration.minutes === 0
              ? `${duration.hours}h`
              : `${duration.hours}h ${duration.minutes}m`;

  return (
    <div className="schedule-rule__time">
      <span className="time__from-to">
        <time dateTime={a11yStartTime}>{startTime}</time> –{" "}
        <time dateTime={a11yEndTime}>{endTime}</time>
      </span>
      <span className="time__duration"> ({durationMessage})</span>
    </div>
  );
};
